import { styled } from 'styled-components';

const PageStyled = styled.div`
  display: flex;
`;

export default PageStyled;
